import { Upgrades } from '../models/upgrades.interfaces';
import {
  Card01Mocks,
  Card02Mocks,
  Card03Mocks,
  Card04Mocks,
  Card05Mocks,
  Card06Mocks
} from './cards.mocks';

export const UpgradesMocks: Upgrades = {
  title: 'Elevate Your Next Flight',
  action: {
    label: 'View All Vouchers and Credits',
    url: '/myprofile/certificates'
  },
  cards: [],
  disabled: false,
  loaded: true
};

export const Upgrades01Mocks = { ...UpgradesMocks };
Upgrades01Mocks.cards = [Card01Mocks];

export const Upgrades02Mocks = { ...UpgradesMocks };
Upgrades02Mocks.cards = [Card01Mocks, Card02Mocks];

export const Upgrades03Mocks = { ...UpgradesMocks };
Upgrades03Mocks.cards = [Card01Mocks, Card02Mocks, Card03Mocks];

export const Upgrades04Mocks = { ...UpgradesMocks };
Upgrades04Mocks.cards = [Card01Mocks, Card02Mocks, Card03Mocks, Card04Mocks];

export const Upgrades05Mocks = { ...UpgradesMocks };
Upgrades05Mocks.cards = [
  Card01Mocks,
  Card02Mocks,
  Card03Mocks,
  Card04Mocks,
  Card05Mocks
];

export const Upgrades06Mocks = { ...UpgradesMocks };
Upgrades06Mocks.cards = [
  Card01Mocks,
  Card02Mocks,
  Card03Mocks,
  Card04Mocks,
  Card05Mocks,
  Card06Mocks
];
